import { type PropsWithChildren } from 'react';

import { useGaugeChartSizeContext } from '../hooks/useGaugeChartSizeContext.js';

export const GaugeRootSVG = ({ children }: PropsWithChildren) => {
  const dimensions = useGaugeChartSizeContext();
  const width = dimensions?.width;
  const height = dimensions?.height;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'block' }}
    >
      <g
        transform={`translate(${
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          width! / 2
        }, ${
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          height! / 2
        })`}
      >
        {children}
      </g>
    </svg>
  );
};
